import { createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "flex-grow-1" }, null, -1 /* HOISTED */)
const _hoisted_2 = { class: "footer-area text-center text-md-start bg-white ps-15 pe-15 pt-20 pb-20 ps-md-40 pe-md-40 pt-md-25 pb-md-25" }
const _hoisted_3 = { class: "row align-items-center" }
const _hoisted_4 = { class: "col-auto" }
const _hoisted_5 = { class: "row align-items-center" }
const _hoisted_6 = { class: "col-auto" }
const _hoisted_7 = { class: "text-body-secondary fw-medium mb-0" }
const _hoisted_8 = { class: "fw-bold text-primary" }
const _hoisted_9 = { class: "text-body-emphasis" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FooterLinks = _resolveComponent("FooterLinks")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("footer", _hoisted_2, [
      _createCommentVNode(" FOOTER LINKS "),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_ctx.env === 'sifi_fk' || _ctx.env === 'fungalk')
            ? (_openBlock(), _createBlock(_component_FooterLinks, { key: 0 }))
            : _createCommentVNode("v-if", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createCommentVNode(" <div class=\"col-md-6 col-lg-6\"> "),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("p", _hoisted_7, [
            _createTextVNode(" © " + _toDisplayString(_ctx.year) + " ", 1 /* TEXT */),
            _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.name), 1 /* TEXT */),
            _createTextVNode(" - " + _toDisplayString(_ctx.disclaimer) + _toDisplayString(_ctx.disclaimer != '' ? ' - ' :
          '') + " ", 1 /* TEXT */),
            _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.version), 1 /* TEXT */)
          ])
        ]),
        _createCommentVNode(" <div class=\"col-md-6 col-lg-6 text-md-end\">\n        <ul class=\"footer-menu ps-0 mb-0 list-unstyled fw-medium\">\n          <li class=\"d-inline-block\">\n            <router-link\n              to=\"/privacy-policy\"\n              class=\"text-decoration-none text-body-secondary transition\"\n            >\n              Privacy Policy\n            </router-link>\n          </li>\n          <li class=\"d-inline-block\">\n            <router-link\n              to=\"/terms-conditions\"\n              class=\"text-decoration-none text-body-secondary transition\"\n            >\n              Terms & Conditions\n            </router-link>\n          </li>\n        </ul>\n      </div> ")
      ])
    ])
  ], 64 /* STABLE_FRAGMENT */))
}